// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.standard-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 10px;
}
.standard-row > * {
  padding: 20px; /* Add padding to all direct children of OTP-Page-Container */
}
.charge-select-add {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 10px;
}
.charge-select {
  margin: 20px;
  width: 50%;
}
.charges-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
}
.charge-item{
  flex: 4 1;
  min-width: 80%;
  width: 80%; /* This makes the first child take up 80% of the available space */
  padding: 10px; /* Adjust padding as needed */
}
.charge-tile {
  display: flex;
}

.finish-charge-container {
  padding: 20px;
}

.finish-charge-container .spoq-product-id-tile {
  width: 90%;
  padding: 10px;
  border: 2px solid #20295b;
  border-radius: 10px;
  margin: 10px
}
.finish-charge-container .spoq-product-id-tile label{
margin-right: 5%;
}

.finish-charge-container .spoq-product-id-tile input[type="file"] {
  display: none;
}

.delete-button{
  border: none;
  display: inline-block;
  padding: 8px 16px;
  vertical-align: middle;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  background-color: inherit;
  text-align: center;
  cursor: pointer;
}

.delete-button{ 
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.delete-button:disabled{
  cursor: not-allowed;
  opacity: 0.3;
}

.delete-button:hover {
  color: #FFF !important;
  background-color: #be0000 !important;
}


/* Copied from https://www.w3schools.com/w3css/4/w3.css for an offline copy*/
/* W3.CSS 4.15 December 2020 by Jan Egil and Borge Refsnes */
/* https://www.w3schools.com/w3css/ */
html {
  box-sizing: border-box;
}

*,
*:before,
*:after {
  box-sizing: inherit;
}

/* Extract from normalize.css by Nicolas Gallagher and Jonathan Neal git.io/normalize */
html {
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}

body {
  margin: 0;
}

:root {
  --blue: #3949a3;
  --darkblue: #20295b;
  --platinum: #e5e5e5;
  --black: #2b2d42;
  --white: #fff;
  --thumb: #edf2f4;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
main,
menu,
nav,
section {
  display: block;
}

div.scrollmenu {
  background-color: #333;
  overflow: auto;
  white-space: nowrap;
}

div.scrollmenu a {
  display: inline-block;
  color: white;
  text-align: center;
  padding: 14px;
  text-decoration: none;
}

div.scrollmenu a:hover {
  background-color: #777;
}

.cards {
  display: grid;
  grid-auto-columns: 100%;
  grid-column-gap: 10px;
  grid-auto-flow: column;
  padding: 25px 0px;
  list-style: none;
  overflow-x: scroll;
  scroll-snap-type: x mandatory;
}


.card {
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: var(--white);
  border-radius: 12px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 15%);
  scroll-snap-align: start;
  transition: all 0.2s;
}

.card:hover {
  color: var(--white);
  background: var(--blue);
}

.card .card-title {
  font-size: 30px;
  font-weight: 500;
}

.card .card-content {
  margin: 20px 0;
  max-width: 85%;
}

.card .card-link-wrapper {
  margin-top: auto;
}

.card .card-link {
  display: inline-block;
  text-decoration: none;
  color: white;
  background: var(--blue);
  padding: 6px 12px;
  border-radius: 8px;
  transition: background 0.2s;
}

.card:hover .card-link {
  background: var(--darkblue);
}

.cards::-webkit-scrollbar {
  height: 12px;
}

.cards::-webkit-scrollbar-thumb,
.cards::-webkit-scrollbar-track {
  border-radius: 92px;
}

.cards::-webkit-scrollbar-thumb {
  background: var(--darkblue);
}

.cards::-webkit-scrollbar-track {
  background: var(--thumb);
}

@media (min-width: 500px) {
  .cards {
    grid-auto-columns: calc(50% - 10px);
    grid-column-gap: 20px;
  }
}

@media (min-width: 700px) {
  .cards {
    grid-auto-columns: calc(calc(100% / 3) - 20px);
    grid-column-gap: 30px;
  }
}

@media (min-width: 1100px) {
  .cards {
    grid-auto-columns: calc(25% - 30px);
    grid-column-gap: 40px;
  }
}

summary {
  display: list-item;
}

audio,
canvas,
progress,
video {
  display: inline-block;
}

progress {
  vertical-align: baseline;
}

audio:not([controls]) {
  display: none;
  height: 0;
}

hr.dotted {
  border-top: 2px dotted #a1b7f1;
}

[hidden],
template {
  display: none;
}

a {
  background-color: transparent;
}

a:active,
a:hover {
  outline-width: 0;
}

abbr[title] {
  border-bottom: none;
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

b,
strong {
  font-weight: bolder;
}

dfn {
  font-style: italic;
}

mark {
  background: #ff0;
  color: #000;
}

small {
  font-size: 80%;
}

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

figure {
  margin: 1em 40px;
}

img {
  border-style: none;
}

code,
kbd,
pre,
samp {
  font-family: monospace, monospace;
  font-size: 1em;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

button,
input,
select,
textarea,
optgroup {
  font: inherit;
  margin: 0;
}

optgroup {
  font-weight: bold;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

button,
[type='button'],
[type='reset'],
[type='submit'] {
  -webkit-appearance: button;
}

button::-moz-focus-inner,
[type='button']::-moz-focus-inner,
[type='reset']::-moz-focus-inner,
[type='submit']::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

button:-moz-focusring,
[type='button']:-moz-focusring,
[type='reset']:-moz-focusring,
[type='submit']:-moz-focusring {
  outline: 1px dotted ButtonText;
}

fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}

legend {
  color: inherit;
  display: table;
  max-width: 100%;
  padding: 0;
  white-space: normal;
}

textarea {
  overflow: auto;
}

[type='checkbox'],
[type='radio'] {
  padding: 0;
}

[type='number']::-webkit-inner-spin-button,
[type='number']::-webkit-outer-spin-button {
  height: auto;
}

[type='search'] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

[type='search']::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  -webkit-appearance: button;
  font: inherit;
}

/* End extract */
html,
body {
  font-family: Verdana, sans-serif;
  font-size: 15px;
  line-height: 1.5;
}

html {
  overflow-x: hidden;
}

h1 {
  font-size: 36px;
}

h2 {
  font-size: 30px;
}

h3 {
  font-size: 24px;
}

h4 {
  font-size: 20px;
}

h5 {
  font-size: 18px;
}

h6 {
  font-size: 16px;
}

.w3-serif {
  font-family: serif;
}

.w3-sans-serif {
  font-family: sans-serif;
}

.w3-cursive {
  font-family: cursive;
}

.w3-monospace {
  font-family: monospace;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: 'Segoe UI', Arial, sans-serif;
  font-weight: 400;
  margin: 10px 0;
}

.w3-wide {
  letter-spacing: 4px;
}

hr {
  border: 0;
  border-top: 1px solid #eee;
  margin: 20px 0;
}

.w3-image {
  max-width: 100%;
  height: auto;
}

img {
  vertical-align: middle;
}

a {
  color: inherit;
}

.container {
  position: relative;
}

.center {
  margin: 0;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0%);
}

.w3-table,
.w3-table-all {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  display: table;
}

.w3-table-all {
  border: 1px solid #ccc;
}

.otp_input {
  width: 32px;
  height: 32px;
  text-align: center;
  border: none;
  border-bottom: 1.5px solid #d2d2d2;
  margin: 0 10px;
}

.w3-bordered tr,
.w3-table-all tr {
  border-bottom: 1px solid #ddd;
}

.w3-striped tbody tr:nth-child(even) {
  background-color: #f1f1f1;
}

.w3-table-all tr:nth-child(odd) {
  background-color: #fff;
}

.w3-table-all tr:nth-child(even) {
  background-color: #f1f1f1;
}

.w3-hoverable tbody tr:hover,
.w3-ul.w3-hoverable li:hover {
  background-color: #ccc;
}

.w3-centered tr th,
.w3-centered tr td {
  text-align: center;
}

.w3-table td,
.w3-table th,
.w3-table-all td,
.w3-table-all th {
  padding: 8px 8px;
  display: table-cell;
  text-align: left;
  vertical-align: top;
}

.w3-table th:first-child,
.w3-table td:first-child,
.w3-table-all th:first-child,
.w3-table-all td:first-child {
  padding-left: 16px;
}

.w3-btn,
.w3-button {
  border: none;
  display: inline-block;
  padding: 8px 16px;
  vertical-align: middle;
  overflow: hidden;
  text-decoration: none;
  color: inherit;
  background-color: inherit;
  text-align: center;
  cursor: pointer;
}

.w3-btn:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.w3-btn,
.w3-button {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

.w3-disabled,
.w3-btn:disabled,
.w3-button:disabled {
  cursor: not-allowed;
  opacity: 0.3;
}

.w3-disabled *,
:disabled * {
  pointer-events: none;
}

.w3-btn.w3-disabled:hover,
.w3-btn:disabled:hover {
  box-shadow: none;
}

.w3-badge,
.w3-tag {
  background-color: #000;
  color: #fff;
  display: inline-block;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
}

.w3-badge {
  border-radius: 50%;
}

.w3-ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.w3-ul li {
  padding: 8px 16px;
  border-bottom: 1px solid #ddd;
}

.edit-product-dialog {
  color: #000;
  position: fixed;
  top: 0;
  left: 0;
  width: 95%;
  height: 95%;
  display: flex;
  justify-content: center;
  border-radius: 20px;
  border-width: 3px;
  border-color: #20295b;
  align-items: center;
  z-index: 9999;
}

.edit-product-dialog-content {
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  width: 90%;
  max-height: 90%;
  max-width: 95%;
  overflow: auto;
  border: 2px solid #20295b; /* Thin black border */
}


.edit-product-dialog button {
  margin-top: 10px;
  margin-right: 10px;
}

/* CSS styles for CookieConsent dialog */
.CookieConsent {
  position: fixed;
  top: 50%;
  left: 20%;
  transform: scaleX(0.7);
  background-color: #000;
  color: #fff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

/* CSS styles for the "Accept" button in the CookieConsent dialog */
.CookieConsent-button {
  background-color: #3949a3;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

/* CSS styles for the message text in the CookieConsent dialog */
.CookieConsent-message {
  margin-right: 16px;
}

.w3-ul li:last-child {
  border-bottom: none;
}

.w3-tooltip,
.w3-display-container {
  position: relative;
}

.w3-tooltip .w3-text {
  display: none;
}

.w3-tooltip:hover .w3-text {
  display: inline-block;
}

.w3-ripple:active {
  opacity: 0.5;
}

.w3-ripple {
  transition: opacity 0s;
}

.w3-input {
  padding: 8px;
  display: block;
  border: none;
  border-bottom: 1px solid #ccc;
  width: 100%;
}

.w3-select {
  padding: 9px 0;
  width: 100%;
  border: none;
  border-bottom: 1px solid #ccc;
}

.w3-dropdown-click,
.w3-dropdown-hover {
  position: relative;
  display: inline-block;
  cursor: pointer;
}

.w3-dropdown-hover:hover .w3-dropdown-content {
  display: block;
}

.w3-dropdown-hover:first-child,
.w3-dropdown-click:hover {
  background-color: #ccc;
  color: #000;
}

.w3-dropdown-hover:hover>.w3-button:first-child,
.w3-dropdown-click:hover>.w3-button:first-child {
  background-color: #ccc;
  color: #000;
}

.w3-dropdown-content {
  cursor: auto;
  color: #000;
  background-color: #fff;
  display: none;
  position: absolute;
  min-width: 160px;
  margin: 0;
  padding: 0;
  z-index: 1;
}

.w3-check,
.w3-radio {
  width: 24px;
  height: 24px;
  position: relative;
  top: 6px;
}

.w3-sidebar {
  height: 100%;
  width: 200px;
  background-color: #fff;
  position: fixed !important;
  z-index: 1;
  overflow: auto;
}

.w3-bar-block .w3-dropdown-hover,
.w3-bar-block .w3-dropdown-click {
  width: 100%;
}

.w3-bar-block .w3-dropdown-hover .w3-dropdown-content,
.w3-bar-block .w3-dropdown-click .w3-dropdown-content {
  min-width: 100%;
}

.w3-bar-block .w3-dropdown-hover .w3-button,
.w3-bar-block .w3-dropdown-click .w3-button {
  width: 100%;
  text-align: left;
  padding: 8px 16px;
}

.w3-main,
#main {
  transition: margin-left 0.4s;
}

.w3-modal {
  z-index: 3;
  display: none;
  padding-top: 100px;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
}

.w3-modal-content {
  margin: auto;
  background-color: #fff;
  position: relative;
  padding: 0;
  outline: 0;
  width: 600px;
}

.w3-bar {
  width: 100%;
  overflow: hidden;
}

.w3-center .w3-bar {
  display: inline-block;
  width: auto;
}

.w3-bar .w3-bar-item {
  padding: 8px 16px;
  float: left;
  width: auto;
  border: none;
  display: block;
  outline: 0;
}

.w3-bar .w3-dropdown-hover,
.w3-bar .w3-dropdown-click {
  position: static;
  float: left;
}

.w3-bar .w3-button {
  white-space: normal;
}

.w3-bar-block .w3-bar-item {
  width: 100%;
  display: block;
  padding: 8px 16px;
  text-align: left;
  border: none;
  white-space: normal;
  float: none;
  outline: 0;
}

.w3-bar-block.w3-center .w3-bar-item {
  text-align: center;
}

.w3-block {
  display: block;
  width: 100%;
}

.w3-responsive {
  display: block;
  overflow-x: auto;
}

.w3-container:after,
.w3-container:before,
.w3-panel:after,
.w3-panel:before,
.w3-row:after,
.w3-row:before,
.w3-row-padding:after,
.w3-row-padding:before,
.w3-cell-row:before,
.w3-cell-row:after,
.w3-clear:after,
.w3-clear:before,
.w3-bar:before,
.w3-bar:after {
  content: '';
  display: table;
  clear: both;
}

.w3-col,
.w3-half,
.w3-third,
.w3-twothird,
.w3-threequarter,
.w3-quarter {
  float: left;
  width: 100%;
}

.w3-col.s1 {
  width: 8.33333%;
}

.w3-col.s2 {
  width: 16.66666%;
}

.w3-col.s3 {
  width: 24.99999%;
}

.w3-col.s4 {
  width: 33.33333%;
}

.w3-col.s5 {
  width: 41.66666%;
}

.w3-col.s6 {
  width: 49.99999%;
}

.w3-col.s7 {
  width: 58.33333%;
}

.w3-col.s8 {
  width: 66.66666%;
}

.w3-col.s9 {
  width: 74.99999%;
}

.w3-col.s10 {
  width: 83.33333%;
}

.w3-col.s11 {
  width: 91.66666%;
}

.w3-col.s12 {
  width: 99.99999%;
}

@media (min-width: 601px) {
  .w3-col.m1 {
    width: 8.33333%;
  }

  .w3-col.m2 {
    width: 16.66666%;
  }

  .w3-col.m3,
  .w3-quarter {
    width: 24.99999%;
  }

  .w3-col.m4,
  .w3-third {
    width: 33.33333%;
  }

  .w3-col.m5 {
    width: 41.66666%;
  }

  .w3-col.m6,
  .w3-half {
    width: 49.99999%;
  }

  .w3-col.m7 {
    width: 58.33333%;
  }

  .w3-col.m8,
  .w3-twothird {
    width: 66.66666%;
  }

  .w3-col.m9,
  .w3-threequarter {
    width: 74.99999%;
  }

  .w3-col.m10 {
    width: 83.33333%;
  }

  .w3-col.m11 {
    width: 91.66666%;
  }

  .w3-col.m12 {
    width: 99.99999%;
  }
}

@media (min-width: 993px) {
  .w3-col.l1 {
    width: 8.33333%;
  }

  .w3-col.l2 {
    width: 16.66666%;
  }

  .w3-col.l3 {
    width: 24.99999%;
  }

  .w3-col.l4 {
    width: 33.33333%;
  }

  .w3-col.l5 {
    width: 41.66666%;
  }

  .w3-col.l6 {
    width: 49.99999%;
  }

  .w3-col.l7 {
    width: 58.33333%;
  }

  .w3-col.l8 {
    width: 66.66666%;
  }

  .w3-col.l9 {
    width: 74.99999%;
  }

  .w3-col.l10 {
    width: 83.33333%;
  }

  .w3-col.l11 {
    width: 91.66666%;
  }

  .w3-col.l12 {
    width: 99.99999%;
  }
}

.w3-rest {
  overflow: hidden;
}

.w3-stretch {
  margin-left: -16px;
  margin-right: -16px;
}

.w3-content,
.w3-auto {
  margin-left: auto;
  margin-right: auto;
}

.w3-content {
  max-width: 980px;
}

.w3-auto {
  max-width: 1140px;
}

.w3-cell-row {
  display: table;
  width: 100%;
}

.w3-cell {
  display: table-cell;
}

.w3-cell-top {
  vertical-align: top;
}

.w3-cell-middle {
  vertical-align: middle;
}

.w3-cell-bottom {
  vertical-align: bottom;
}

.w3-hide {
  display: none !important;
}

.w3-show-block,
.w3-show {
  display: block !important;
}

.w3-show-inline-block {
  display: inline-block !important;
}

@media (max-width: 1205px) {
  .w3-auto {
    max-width: 95%;
  }
}

@media (max-width: 600px) {
  .w3-modal-content {
    margin: 0 10px;
    width: auto !important;
  }

  .w3-modal {
    padding-top: 30px;
  }

  .w3-dropdown-hover.w3-mobile .w3-dropdown-content,
  .w3-dropdown-click.w3-mobile .w3-dropdown-content {
    position: relative;
  }

  .w3-hide-small {
    display: none !important;
  }

  .w3-mobile {
    display: block;
    width: 100% !important;
  }

  .w3-bar-item.w3-mobile,
  .w3-dropdown-hover.w3-mobile,
  .w3-dropdown-click.w3-mobile {
    text-align: center;
  }

  .w3-dropdown-hover.w3-mobile,
  .w3-dropdown-hover.w3-mobile .w3-btn,
  .w3-dropdown-hover.w3-mobile .w3-button,
  .w3-dropdown-click.w3-mobile,
  .w3-dropdown-click.w3-mobile .w3-btn,
  .w3-dropdown-click.w3-mobile .w3-button {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .w3-modal-content {
    width: 500px;
  }

  .w3-modal {
    padding-top: 50px;
  }
}

@media (min-width: 993px) {
  .w3-modal-content {
    width: 900px;
  }

  .w3-hide-large {
    display: none !important;
  }

  .w3-sidebar.w3-collapse {
    display: block !important;
  }
}

@media (max-width: 992px) and (min-width: 601px) {
  .w3-hide-medium {
    display: none !important;
  }
}

@media (max-width: 992px) {
  .w3-sidebar.w3-collapse {
    display: none;
  }

  .w3-main {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .w3-auto {
    max-width: 100%;
  }
}

.w3-top,
.w3-bottom {
  position:sticky;
  width: 100%;
  z-index: 1000;
}

.w3-top {
  top: 0;
}

.w3-bottom {
  bottom: 0;
}

.w3-overlay {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
}

.w3-display-topleft {
  position: absolute;
  left: 0;
  top: 0;
}

.w3-display-topright {
  position: absolute;
  right: 0;
  top: 0;
}

.w3-display-bottomleft {
  position: absolute;
  left: 0;
  bottom: 0;
}

.w3-display-bottomright {
  position: absolute;
  right: 0;
  bottom: 0;
}

.w3-display-middle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
}

.w3-display-left {
  position: absolute;
  top: 50%;
  left: 0%;
  transform: translate(0%, -50%);
  -ms-transform: translate(-0%, -50%);
}

.w3-display-right {
  position: absolute;
  top: 50%;
  right: 0%;
  transform: translate(0%, -50%);
  -ms-transform: translate(0%, -50%);
}

.w3-display-topmiddle {
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, 0%);
  -ms-transform: translate(-50%, 0%);
}

.w3-display-bottommiddle {
  position: absolute;
  left: 50%;
  bottom: 0;
  transform: translate(-50%, 0%);
  -ms-transform: translate(-50%, 0%);
}

.w3-display-container:hover .w3-display-hover {
  display: block;
}

.w3-display-container:hover span.w3-display-hover {
  display: inline-block;
}

.w3-display-hover {
  display: none;
}

.w3-display-position {
  position: absolute;
}

.w3-circle {
  border-radius: 50%;
}

.w3-round-small {
  border-radius: 2px;
}

.w3-round,
.w3-round-medium {
  border-radius: 4px;
}

.w3-round-large {
  border-radius: 8px;
}

.w3-round-xlarge {
  border-radius: 16px;
}

.w3-round-xxlarge {
  border-radius: 32px;
}

.w3-row-padding,
.w3-row-padding>.w3-half,
.w3-row-padding>.w3-third,
.w3-row-padding>.w3-twothird,
.w3-row-padding>.w3-threequarter,
.w3-row-padding>.w3-quarter,
.w3-row-padding>.w3-col {
  padding: 0 8px;
}

.w3-container,
.w3-panel {
  padding: 0.01em 16px;
}

.w3-panel {
  margin-top: 16px;
  margin-bottom: 16px;
}

.w3-code,
.w3-codespan {
  font-family: Consolas, 'courier new';
  font-size: 16px;
}

.w3-code {
  width: auto;
  background-color: #fff;
  padding: 8px 12px;
  border-left: 4px solid #4caf50;
  word-wrap: break-word;
}

.w3-codespan {
  color: crimson;
  background-color: #f1f1f1;
  padding-left: 4px;
  padding-right: 4px;
  font-size: 110%;
}

.w3-card,
.w3-card-2 {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}

.w3-card-4,
.w3-hover-shadow:hover {
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2), 0 4px 20px 0 rgba(0, 0, 0, 0.19);
}

.w3-spin {
  animation: w3-spin 2s infinite linear;
}

@keyframes w3-spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(359deg);
  }
}

.w3-animate-fading {
  animation: fading 10s infinite;
}

@keyframes fading {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
}

.w3-animate-opacity {
  animation: opac 0.8s;
}

@keyframes opac {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.w3-animate-top {
  position: relative;
  animation: animatetop 0.4s;
}

@keyframes animatetop {
  from {
    top: -300px;
    opacity: 0;
  }

  to {
    top: 0;
    opacity: 1;
  }
}

.w3-animate-left {
  position: relative;
  animation: animateleft 0.4s;
}

@keyframes animateleft {
  from {
    left: -300px;
    opacity: 0;
  }

  to {
    left: 0;
    opacity: 1;
  }
}

.w3-animate-right {
  position: relative;
  animation: animateright 0.4s;
}

@keyframes animateright {
  from {
    right: -300px;
    opacity: 0;
  }

  to {
    right: 0;
    opacity: 1;
  }
}

.w3-animate-bottom {
  position: relative;
  animation: animatebottom 0.4s;
}

@keyframes animatebottom {
  from {
    bottom: -300px;
    opacity: 0;
  }

  to {
    bottom: 0;
    opacity: 1;
  }
}

.w3-animate-zoom {
  animation: animatezoom 0.6s;
}

@keyframes animatezoom {
  from {
    transform: scale(0);
  }

  to {
    transform: scale(1);
  }
}

.w3-animate-input {
  transition: width 0.4s ease-in-out;
}

.w3-animate-input:focus {
  width: 100% !important;
}

.w3-opacity,
.w3-hover-opacity:hover {
  opacity: 0.6;
}

.w3-opacity-off,
.w3-hover-opacity-off:hover {
  opacity: 1;
}

.w3-opacity-max {
  opacity: 0.25;
}

.w3-opacity-min {
  opacity: 0.75;
}

.w3-greyscale-max,
.w3-grayscale-max,
.w3-hover-greyscale:hover,
.w3-hover-grayscale:hover {
  filter: grayscale(100%);
}

.w3-greyscale,
.w3-grayscale {
  filter: grayscale(75%);
}

.w3-greyscale-min,
.w3-grayscale-min {
  filter: grayscale(50%);
}

.w3-sepia {
  filter: sepia(75%);
}

.w3-sepia-max,
.w3-hover-sepia:hover {
  filter: sepia(100%);
}

.w3-sepia-min {
  filter: sepia(50%);
}

.w3-tiny {
  font-size: 10px !important;
}

.w3-small {
  font-size: 12px !important;
}

.w3-medium {
  font-size: 15px !important;
}

.w3-large {
  font-size: 18px !important;
}

.w3-xlarge {
  font-size: 24px !important;
}

.w3-xxlarge {
  font-size: 36px !important;
}

.w3-xxxlarge {
  font-size: 48px !important;
}

.w3-jumbo {
  font-size: 64px !important;
}

.w3-left-align {
  text-align: left !important;
}

.w3-right-align {
  text-align: right !important;
}

.w3-justify {
  text-align: justify !important;
}

.w3-center {
  text-align: center !important;
}

.w3-border-0 {
  border: 0 !important;
}

.w3-border {
  border: 1px solid #ccc !important;
}

.w3-border-top {
  border-top: 1px solid #ccc !important;
}

.w3-border-bottom {
  border-bottom: 1px solid #ccc !important;
}

.w3-border-left {
  border-left: 1px solid #ccc !important;
}

.w3-border-right {
  border-right: 1px solid #ccc !important;
}

.w3-topbar {
  border-top: 6px solid #ccc !important;
}

.w3-bottombar {
  border-bottom: 6px solid #ccc !important;
}

.w3-leftbar {
  border-left: 6px solid #ccc !important;
}

.w3-rightbar {
  border-right: 6px solid #ccc !important;
}

.w3-section,
.w3-code {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}

.w3-margin {
  margin: 16px !important;
}

.w3-margin-top {
  margin-top: 16px !important;
}

.w3-margin-bottom {
  margin-bottom: 16px !important;
}

.w3-margin-left {
  margin-left: 16px !important;
}

.w3-margin-right {
  margin-right: 16px !important;
}

.w3-padding-small {
  padding: 4px 8px !important;
}

.w3-padding {
  padding: 8px 16px !important;
}

.w3-padding-large {
  padding: 12px 24px !important;
}

.w3-padding-16 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.w3-padding-24 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

.w3-padding-32 {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}

.w3-padding-48 {
  padding-top: 48px !important;
  padding-bottom: 48px !important;
}

.w3-padding-64 {
  padding-top: 64px !important;
  padding-bottom: 64px !important;
}

.w3-padding-top-64 {
  padding-top: 64px !important;
}

.w3-padding-top-48 {
  padding-top: 48px !important;
}

.w3-padding-top-32 {
  padding-top: 32px !important;
}

.w3-padding-top-24 {
  padding-top: 24px !important;
}

.w3-left {
  float: left !important;
}

.w3-right {
  float: right !important;
}

.w3-button:hover {
  color: #000 !important;
  background-color: #ccc !important;
}

.w3-transparent,
.w3-hover-none:hover {
  background-color: transparent !important;
}

.w3-hover-none:hover {
  box-shadow: none !important;
}

/* Colors */
.w3-amber,
.w3-hover-amber:hover {
  color: #000 !important;
  background-color: #ffc107 !important;
}

.w3-aqua,
.w3-hover-aqua:hover {
  color: #000 !important;
  background-color: #00ffff !important;
}

.w3-blue,
.w3-hover-blue:hover {
  color: #fff !important;
  background-color: #2196f3 !important;
}

.w3-light-blue,
.w3-hover-light-blue:hover {
  color: #000 !important;
  background-color: #87ceeb !important;
}

.w3-brown,
.w3-hover-brown:hover {
  color: #fff !important;
  background-color: #795548 !important;
}

.w3-cyan,
.w3-hover-cyan:hover {
  color: #000 !important;
  background-color: #00bcd4 !important;
}

.w3-blue-grey,
.w3-hover-blue-grey:hover,
.w3-blue-gray,
.w3-hover-blue-gray:hover {
  color: #fff !important;
  background-color: #607d8b !important;
}

.w3-green,
.w3-hover-green:hover {
  color: #fff !important;
  background-color: #4caf50 !important;
}

.w3-light-green,
.w3-hover-light-green:hover {
  color: #000 !important;
  background-color: #8bc34a !important;
}

.w3-indigo,
.w3-hover-indigo:hover {
  color: #fff !important;
  background-color: #3f51b5 !important;
}

.w3-khaki,
.w3-hover-khaki:hover {
  color: #000 !important;
  background-color: #f0e68c !important;
}

.w3-lime,
.w3-hover-lime:hover {
  color: #000 !important;
  background-color: #cddc39 !important;
}

.w3-orange,
.w3-hover-orange:hover {
  color: #000 !important;
  background-color: #ff9800 !important;
}

.w3-deep-orange,
.w3-hover-deep-orange:hover {
  color: #fff !important;
  background-color: #ff5722 !important;
}

.w3-pink,
.w3-hover-pink:hover {
  color: #fff !important;
  background-color: #e91e63 !important;
}

.w3-purple,
.w3-hover-purple:hover {
  color: #fff !important;
  background-color: #9c27b0 !important;
}

.w3-deep-purple,
.w3-hover-deep-purple:hover {
  color: #fff !important;
  background-color: #673ab7 !important;
}

.w3-red,
.w3-hover-red:hover {
  color: #fff !important;
  background-color: #f44336 !important;
}

.w3-sand,
.w3-hover-sand:hover {
  color: #000 !important;
  background-color: #fdf5e6 !important;
}

.w3-teal,
.w3-hover-teal:hover {
  color: #fff !important;
  background-color: #009688 !important;
}

.w3-yellow,
.w3-hover-yellow:hover {
  color: #000 !important;
  background-color: #ffeb3b !important;
}

.w3-white,
.w3-hover-white:hover {
  color: #000 !important;
  background-color: #fff !important;
}

.w3-black,
.w3-hover-black:hover {
  color: #fff !important;
  background-color: #000 !important;
}

.w3-grey,
.w3-hover-grey:hover,
.w3-gray,
.w3-hover-gray:hover {
  color: #000 !important;
  background-color: #9e9e9e !important;
}

.w3-light-grey,
.w3-hover-light-grey:hover,
.w3-light-gray,
.w3-hover-light-gray:hover {
  color: #000 !important;
  background-color: #f1f1f1 !important;
}

.w3-dark-grey,
.w3-hover-dark-grey:hover,
.w3-dark-gray,
.w3-hover-dark-gray:hover {
  color: #fff !important;
  background-color: #616161 !important;
}

.w3-pale-red,
.w3-hover-pale-red:hover {
  color: #000 !important;
  background-color: #ffdddd !important;
}

.w3-pale-green,
.w3-hover-pale-green:hover {
  color: #000 !important;
  background-color: #ddffdd !important;
}

.w3-pale-yellow,
.w3-hover-pale-yellow:hover {
  color: #000 !important;
  background-color: #ffffcc !important;
}

.w3-pale-blue,
.w3-hover-pale-blue:hover {
  color: #000 !important;
  background-color: #ddffff !important;
}

.w3-text-amber,
.w3-hover-text-amber:hover {
  color: #ffc107 !important;
}

.w3-text-aqua,
.w3-hover-text-aqua:hover {
  color: #00ffff !important;
}

.w3-text-blue,
.w3-hover-text-blue:hover {
  color: #2196f3 !important;
}

.w3-text-light-blue,
.w3-hover-text-light-blue:hover {
  color: #87ceeb !important;
}

.w3-text-brown,
.w3-hover-text-brown:hover {
  color: #795548 !important;
}

.w3-text-cyan,
.w3-hover-text-cyan:hover {
  color: #00bcd4 !important;
}

.w3-text-blue-grey,
.w3-hover-text-blue-grey:hover,
.w3-text-blue-gray,
.w3-hover-text-blue-gray:hover {
  color: #607d8b !important;
}

.w3-text-green,
.w3-hover-text-green:hover {
  color: #4caf50 !important;
}

.w3-text-light-green,
.w3-hover-text-light-green:hover {
  color: #8bc34a !important;
}

.w3-text-indigo,
.w3-hover-text-indigo:hover {
  color: #3f51b5 !important;
}

.w3-text-khaki,
.w3-hover-text-khaki:hover {
  color: #b4aa50 !important;
}

.w3-text-lime,
.w3-hover-text-lime:hover {
  color: #cddc39 !important;
}

.w3-text-orange,
.w3-hover-text-orange:hover {
  color: #ff9800 !important;
}

.w3-text-deep-orange,
.w3-hover-text-deep-orange:hover {
  color: #ff5722 !important;
}

.w3-text-pink,
.w3-hover-text-pink:hover {
  color: #e91e63 !important;
}

.w3-text-purple,
.w3-hover-text-purple:hover {
  color: #9c27b0 !important;
}

.w3-text-deep-purple,
.w3-hover-text-deep-purple:hover {
  color: #673ab7 !important;
}

.w3-text-red,
.w3-hover-text-red:hover {
  color: #f44336 !important;
}

.w3-text-sand,
.w3-hover-text-sand:hover {
  color: #fdf5e6 !important;
}

.w3-text-teal,
.w3-hover-text-teal:hover {
  color: #009688 !important;
}

.w3-text-yellow,
.w3-hover-text-yellow:hover {
  color: #d2be0e !important;
}

.w3-text-white,
.w3-hover-text-white:hover {
  color: #fff !important;
}

.w3-text-black,
.w3-hover-text-black:hover {
  color: #000 !important;
}

.w3-text-grey,
.w3-hover-text-grey:hover,
.w3-text-gray,
.w3-hover-text-gray:hover {
  color: #757575 !important;
}

.w3-text-light-grey,
.w3-hover-text-light-grey:hover,
.w3-text-light-gray,
.w3-hover-text-light-gray:hover {
  color: #f1f1f1 !important;
}

.w3-text-dark-grey,
.w3-hover-text-dark-grey:hover,
.w3-text-dark-gray,
.w3-hover-text-dark-gray:hover {
  color: #3a3a3a !important;
}

.w3-border-amber,
.w3-hover-border-amber:hover {
  border-color: #ffc107 !important;
}

.w3-border-aqua,
.w3-hover-border-aqua:hover {
  border-color: #00ffff !important;
}

.w3-border-blue,
.w3-hover-border-blue:hover {
  border-color: #2196f3 !important;
}

.w3-border-light-blue,
.w3-hover-border-light-blue:hover {
  border-color: #87ceeb !important;
}

.w3-border-brown,
.w3-hover-border-brown:hover {
  border-color: #795548 !important;
}

.w3-border-cyan,
.w3-hover-border-cyan:hover {
  border-color: #00bcd4 !important;
}

.w3-border-blue-grey,
.w3-hover-border-blue-grey:hover,
.w3-border-blue-gray,
.w3-hover-border-blue-gray:hover {
  border-color: #607d8b !important;
}

.w3-border-green,
.w3-hover-border-green:hover {
  border-color: #4caf50 !important;
}

.w3-border-light-green,
.w3-hover-border-light-green:hover {
  border-color: #8bc34a !important;
}

.w3-border-indigo,
.w3-hover-border-indigo:hover {
  border-color: #3f51b5 !important;
}

.w3-border-khaki,
.w3-hover-border-khaki:hover {
  border-color: #f0e68c !important;
}

.w3-border-lime,
.w3-hover-border-lime:hover {
  border-color: #cddc39 !important;
}

.w3-border-orange,
.w3-hover-border-orange:hover {
  border-color: #ff9800 !important;
}

.w3-border-deep-orange,
.w3-hover-border-deep-orange:hover {
  border-color: #ff5722 !important;
}

.w3-border-pink,
.w3-hover-border-pink:hover {
  border-color: #e91e63 !important;
}

.w3-border-purple,
.w3-hover-border-purple:hover {
  border-color: #9c27b0 !important;
}

.w3-border-deep-purple,
.w3-hover-border-deep-purple:hover {
  border-color: #673ab7 !important;
}

.w3-border-red,
.w3-hover-border-red:hover {
  border-color: #f44336 !important;
}

.w3-border-sand,
.w3-hover-border-sand:hover {
  border-color: #fdf5e6 !important;
}

.w3-border-teal,
.w3-hover-border-teal:hover {
  border-color: #009688 !important;
}

.w3-border-yellow,
.w3-hover-border-yellow:hover {
  border-color: #ffeb3b !important;
}

.w3-border-white,
.w3-hover-border-white:hover {
  border-color: #fff !important;
}

.w3-border-black,
.w3-hover-border-black:hover {
  border-color: #000 !important;
}

.w3-border-grey,
.w3-hover-border-grey:hover,
.w3-border-gray,
.w3-hover-border-gray:hover {
  border-color: #9e9e9e !important;
}

.w3-border-light-grey,
.w3-hover-border-light-grey:hover,
.w3-border-light-gray,
.w3-hover-border-light-gray:hover {
  border-color: #f1f1f1 !important;
}

.w3-border-dark-grey,
.w3-hover-border-dark-grey:hover,
.w3-border-dark-gray,
.w3-hover-border-dark-gray:hover {
  border-color: #616161 !important;
}

.w3-border-pale-red,
.w3-hover-border-pale-red:hover {
  border-color: #ffe7e7 !important;
}

.w3-border-pale-green,
.w3-hover-border-pale-green:hover {
  border-color: #e7ffe7 !important;
}

.w3-border-pale-yellow,
.w3-hover-border-pale-yellow:hover {
  border-color: #ffffcc !important;
}

.w3-border-pale-blue,
.w3-hover-border-pale-blue:hover {
  border-color: #e7ffff !important;
}

td:nth-child(1) {
  background-color: rgb(43, 45, 133);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/css/basicStyle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa,EAAE,6DAA6D;AAC9E;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;EACZ,UAAU;AACZ;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;AACA;EACE,SAAO;EACP,cAAc;EACd,UAAU,EAAE,kEAAkE;EAC9E,aAAa,EAAE,6BAA6B;AAC9C;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB;AACF;AACA;AACA,gBAAgB;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EAIzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;AACtC;;;AAGA,4EAA4E;AAC5E,4DAA4D;AAC5D,qCAAqC;AACrC;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA,uFAAuF;AACvF;EACE,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;;;;;;;EAWE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;AAC/B;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,mBAAmB;EACnB,yCAAyC;EACzC,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,mCAAmC;IACnC,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,8CAA8C;IAC9C,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,mCAAmC;IACnC,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,yCAAiC;UAAjC,iCAAiC;AACnC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;;;EAIE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA,gBAAgB;AAChB;;EAEE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;;;EAME,0CAA0C;EAC1C,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,SAAS;EAET,8BAA8B;AAChC;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;;;EAIE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;;EAEE,2BAA2B;EAC3B,yBAAyB;EAIzB,iBAAiB;AACnB;;AAEA;;;EAGE,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,UAAU;EACV,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,cAAc;EACd,cAAc;EACd,yBAAyB,EAAE,sBAAsB;AACnD;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,wCAAwC;AACxC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,mEAAmE;AACnE;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,0BAA0B;EAC1B,UAAU;EACV,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,cAAc;EACd,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;EAcE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;;;;;;EAME,WAAW;EACX,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,sBAAsB;EACxB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;;;;;;IAME,WAAW;EACb;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;AACR;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,6EAA6E;AAC/E;;AAEA;;EAEE,6EAA6E;AAC/E;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,MAAM;IACN,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE;IACE,YAAY;IACZ,UAAU;EACZ;;EAEA;IACE,OAAO;IACP,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,uBAAuB;AACzB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,WAAW;AACX;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;;;EAIE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;;EAEE,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;;;;EAIE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;;;EAIE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;;;EAIE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;;;EAIE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd","sourcesContent":[".standard-row {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 10px;\r\n}\r\n.standard-row > * {\r\n  padding: 20px; /* Add padding to all direct children of OTP-Page-Container */\r\n}\r\n.charge-select-add {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 10px;\r\n}\r\n.charge-select {\r\n  margin: 20px;\r\n  width: 50%;\r\n}\r\n.charges-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  width: 100%;\r\n}\r\n.charge-item{\r\n  flex: 4;\r\n  min-width: 80%;\r\n  width: 80%; /* This makes the first child take up 80% of the available space */\r\n  padding: 10px; /* Adjust padding as needed */\r\n}\r\n.charge-tile {\r\n  display: flex;\r\n}\r\n\r\n.finish-charge-container {\r\n  padding: 20px;\r\n}\r\n\r\n.finish-charge-container .spoq-product-id-tile {\r\n  width: 90%;\r\n  padding: 10px;\r\n  border: 2px solid #20295b;\r\n  border-radius: 10px;\r\n  margin: 10px\r\n}\r\n.finish-charge-container .spoq-product-id-tile label{\r\nmargin-right: 5%;\r\n}\r\n\r\n.finish-charge-container .spoq-product-id-tile input[type=\"file\"] {\r\n  display: none;\r\n}\r\n\r\n.delete-button{\r\n  border: none;\r\n  display: inline-block;\r\n  padding: 8px 16px;\r\n  vertical-align: middle;\r\n  overflow: hidden;\r\n  text-decoration: none;\r\n  color: inherit;\r\n  background-color: inherit;\r\n  text-align: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.delete-button{ \r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -khtml-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.delete-button:disabled{\r\n  cursor: not-allowed;\r\n  opacity: 0.3;\r\n}\r\n\r\n.delete-button:hover {\r\n  color: #FFF !important;\r\n  background-color: #be0000 !important;\r\n}\r\n\r\n\r\n/* Copied from https://www.w3schools.com/w3css/4/w3.css for an offline copy*/\r\n/* W3.CSS 4.15 December 2020 by Jan Egil and Borge Refsnes */\r\n/* https://www.w3schools.com/w3css/ */\r\nhtml {\r\n  box-sizing: border-box;\r\n}\r\n\r\n*,\r\n*:before,\r\n*:after {\r\n  box-sizing: inherit;\r\n}\r\n\r\n/* Extract from normalize.css by Nicolas Gallagher and Jonathan Neal git.io/normalize */\r\nhtml {\r\n  -ms-text-size-adjust: 100%;\r\n  -webkit-text-size-adjust: 100%;\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n}\r\n\r\n:root {\r\n  --blue: #3949a3;\r\n  --darkblue: #20295b;\r\n  --platinum: #e5e5e5;\r\n  --black: #2b2d42;\r\n  --white: #fff;\r\n  --thumb: #edf2f4;\r\n}\r\n\r\narticle,\r\naside,\r\ndetails,\r\nfigcaption,\r\nfigure,\r\nfooter,\r\nheader,\r\nmain,\r\nmenu,\r\nnav,\r\nsection {\r\n  display: block;\r\n}\r\n\r\ndiv.scrollmenu {\r\n  background-color: #333;\r\n  overflow: auto;\r\n  white-space: nowrap;\r\n}\r\n\r\ndiv.scrollmenu a {\r\n  display: inline-block;\r\n  color: white;\r\n  text-align: center;\r\n  padding: 14px;\r\n  text-decoration: none;\r\n}\r\n\r\ndiv.scrollmenu a:hover {\r\n  background-color: #777;\r\n}\r\n\r\n.cards {\r\n  display: grid;\r\n  grid-auto-columns: 100%;\r\n  grid-column-gap: 10px;\r\n  grid-auto-flow: column;\r\n  padding: 25px 0px;\r\n  list-style: none;\r\n  overflow-x: scroll;\r\n  scroll-snap-type: x mandatory;\r\n}\r\n\r\n\r\n.card {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  background: var(--white);\r\n  border-radius: 12px;\r\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 15%);\r\n  scroll-snap-align: start;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.card:hover {\r\n  color: var(--white);\r\n  background: var(--blue);\r\n}\r\n\r\n.card .card-title {\r\n  font-size: 30px;\r\n  font-weight: 500;\r\n}\r\n\r\n.card .card-content {\r\n  margin: 20px 0;\r\n  max-width: 85%;\r\n}\r\n\r\n.card .card-link-wrapper {\r\n  margin-top: auto;\r\n}\r\n\r\n.card .card-link {\r\n  display: inline-block;\r\n  text-decoration: none;\r\n  color: white;\r\n  background: var(--blue);\r\n  padding: 6px 12px;\r\n  border-radius: 8px;\r\n  transition: background 0.2s;\r\n}\r\n\r\n.card:hover .card-link {\r\n  background: var(--darkblue);\r\n}\r\n\r\n.cards::-webkit-scrollbar {\r\n  height: 12px;\r\n}\r\n\r\n.cards::-webkit-scrollbar-thumb,\r\n.cards::-webkit-scrollbar-track {\r\n  border-radius: 92px;\r\n}\r\n\r\n.cards::-webkit-scrollbar-thumb {\r\n  background: var(--darkblue);\r\n}\r\n\r\n.cards::-webkit-scrollbar-track {\r\n  background: var(--thumb);\r\n}\r\n\r\n@media (min-width: 500px) {\r\n  .cards {\r\n    grid-auto-columns: calc(50% - 10px);\r\n    grid-column-gap: 20px;\r\n  }\r\n}\r\n\r\n@media (min-width: 700px) {\r\n  .cards {\r\n    grid-auto-columns: calc(calc(100% / 3) - 20px);\r\n    grid-column-gap: 30px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1100px) {\r\n  .cards {\r\n    grid-auto-columns: calc(25% - 30px);\r\n    grid-column-gap: 40px;\r\n  }\r\n}\r\n\r\nsummary {\r\n  display: list-item;\r\n}\r\n\r\naudio,\r\ncanvas,\r\nprogress,\r\nvideo {\r\n  display: inline-block;\r\n}\r\n\r\nprogress {\r\n  vertical-align: baseline;\r\n}\r\n\r\naudio:not([controls]) {\r\n  display: none;\r\n  height: 0;\r\n}\r\n\r\nhr.dotted {\r\n  border-top: 2px dotted #a1b7f1;\r\n}\r\n\r\n[hidden],\r\ntemplate {\r\n  display: none;\r\n}\r\n\r\na {\r\n  background-color: transparent;\r\n}\r\n\r\na:active,\r\na:hover {\r\n  outline-width: 0;\r\n}\r\n\r\nabbr[title] {\r\n  border-bottom: none;\r\n  text-decoration: underline;\r\n  text-decoration: underline dotted;\r\n}\r\n\r\nb,\r\nstrong {\r\n  font-weight: bolder;\r\n}\r\n\r\ndfn {\r\n  font-style: italic;\r\n}\r\n\r\nmark {\r\n  background: #ff0;\r\n  color: #000;\r\n}\r\n\r\nsmall {\r\n  font-size: 80%;\r\n}\r\n\r\nsub,\r\nsup {\r\n  font-size: 75%;\r\n  line-height: 0;\r\n  position: relative;\r\n  vertical-align: baseline;\r\n}\r\n\r\nsub {\r\n  bottom: -0.25em;\r\n}\r\n\r\nsup {\r\n  top: -0.5em;\r\n}\r\n\r\nfigure {\r\n  margin: 1em 40px;\r\n}\r\n\r\nimg {\r\n  border-style: none;\r\n}\r\n\r\ncode,\r\nkbd,\r\npre,\r\nsamp {\r\n  font-family: monospace, monospace;\r\n  font-size: 1em;\r\n}\r\n\r\nhr {\r\n  box-sizing: content-box;\r\n  height: 0;\r\n  overflow: visible;\r\n}\r\n\r\nbutton,\r\ninput,\r\nselect,\r\ntextarea,\r\noptgroup {\r\n  font: inherit;\r\n  margin: 0;\r\n}\r\n\r\noptgroup {\r\n  font-weight: bold;\r\n}\r\n\r\nbutton,\r\ninput {\r\n  overflow: visible;\r\n}\r\n\r\nbutton,\r\nselect {\r\n  text-transform: none;\r\n}\r\n\r\nbutton,\r\n[type='button'],\r\n[type='reset'],\r\n[type='submit'] {\r\n  -webkit-appearance: button;\r\n}\r\n\r\nbutton::-moz-focus-inner,\r\n[type='button']::-moz-focus-inner,\r\n[type='reset']::-moz-focus-inner,\r\n[type='submit']::-moz-focus-inner {\r\n  border-style: none;\r\n  padding: 0;\r\n}\r\n\r\nbutton:-moz-focusring,\r\n[type='button']:-moz-focusring,\r\n[type='reset']:-moz-focusring,\r\n[type='submit']:-moz-focusring {\r\n  outline: 1px dotted ButtonText;\r\n}\r\n\r\nfieldset {\r\n  border: 1px solid #c0c0c0;\r\n  margin: 0 2px;\r\n  padding: 0.35em 0.625em 0.75em;\r\n}\r\n\r\nlegend {\r\n  color: inherit;\r\n  display: table;\r\n  max-width: 100%;\r\n  padding: 0;\r\n  white-space: normal;\r\n}\r\n\r\ntextarea {\r\n  overflow: auto;\r\n}\r\n\r\n[type='checkbox'],\r\n[type='radio'] {\r\n  padding: 0;\r\n}\r\n\r\n[type='number']::-webkit-inner-spin-button,\r\n[type='number']::-webkit-outer-spin-button {\r\n  height: auto;\r\n}\r\n\r\n[type='search'] {\r\n  -webkit-appearance: textfield;\r\n  outline-offset: -2px;\r\n}\r\n\r\n[type='search']::-webkit-search-decoration {\r\n  -webkit-appearance: none;\r\n}\r\n\r\n::-webkit-file-upload-button {\r\n  -webkit-appearance: button;\r\n  font: inherit;\r\n}\r\n\r\n/* End extract */\r\nhtml,\r\nbody {\r\n  font-family: Verdana, sans-serif;\r\n  font-size: 15px;\r\n  line-height: 1.5;\r\n}\r\n\r\nhtml {\r\n  overflow-x: hidden;\r\n}\r\n\r\nh1 {\r\n  font-size: 36px;\r\n}\r\n\r\nh2 {\r\n  font-size: 30px;\r\n}\r\n\r\nh3 {\r\n  font-size: 24px;\r\n}\r\n\r\nh4 {\r\n  font-size: 20px;\r\n}\r\n\r\nh5 {\r\n  font-size: 18px;\r\n}\r\n\r\nh6 {\r\n  font-size: 16px;\r\n}\r\n\r\n.w3-serif {\r\n  font-family: serif;\r\n}\r\n\r\n.w3-sans-serif {\r\n  font-family: sans-serif;\r\n}\r\n\r\n.w3-cursive {\r\n  font-family: cursive;\r\n}\r\n\r\n.w3-monospace {\r\n  font-family: monospace;\r\n}\r\n\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n  font-family: 'Segoe UI', Arial, sans-serif;\r\n  font-weight: 400;\r\n  margin: 10px 0;\r\n}\r\n\r\n.w3-wide {\r\n  letter-spacing: 4px;\r\n}\r\n\r\nhr {\r\n  border: 0;\r\n  border-top: 1px solid #eee;\r\n  margin: 20px 0;\r\n}\r\n\r\n.w3-image {\r\n  max-width: 100%;\r\n  height: auto;\r\n}\r\n\r\nimg {\r\n  vertical-align: middle;\r\n}\r\n\r\na {\r\n  color: inherit;\r\n}\r\n\r\n.container {\r\n  position: relative;\r\n}\r\n\r\n.center {\r\n  margin: 0;\r\n  position: absolute;\r\n  left: 50%;\r\n  -ms-transform: translate(-50%, 0%);\r\n  transform: translate(-50%, 0%);\r\n}\r\n\r\n.w3-table,\r\n.w3-table-all {\r\n  border-collapse: collapse;\r\n  border-spacing: 0;\r\n  width: 100%;\r\n  display: table;\r\n}\r\n\r\n.w3-table-all {\r\n  border: 1px solid #ccc;\r\n}\r\n\r\n.otp_input {\r\n  width: 32px;\r\n  height: 32px;\r\n  text-align: center;\r\n  border: none;\r\n  border-bottom: 1.5px solid #d2d2d2;\r\n  margin: 0 10px;\r\n}\r\n\r\n.w3-bordered tr,\r\n.w3-table-all tr {\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.w3-striped tbody tr:nth-child(even) {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n.w3-table-all tr:nth-child(odd) {\r\n  background-color: #fff;\r\n}\r\n\r\n.w3-table-all tr:nth-child(even) {\r\n  background-color: #f1f1f1;\r\n}\r\n\r\n.w3-hoverable tbody tr:hover,\r\n.w3-ul.w3-hoverable li:hover {\r\n  background-color: #ccc;\r\n}\r\n\r\n.w3-centered tr th,\r\n.w3-centered tr td {\r\n  text-align: center;\r\n}\r\n\r\n.w3-table td,\r\n.w3-table th,\r\n.w3-table-all td,\r\n.w3-table-all th {\r\n  padding: 8px 8px;\r\n  display: table-cell;\r\n  text-align: left;\r\n  vertical-align: top;\r\n}\r\n\r\n.w3-table th:first-child,\r\n.w3-table td:first-child,\r\n.w3-table-all th:first-child,\r\n.w3-table-all td:first-child {\r\n  padding-left: 16px;\r\n}\r\n\r\n.w3-btn,\r\n.w3-button {\r\n  border: none;\r\n  display: inline-block;\r\n  padding: 8px 16px;\r\n  vertical-align: middle;\r\n  overflow: hidden;\r\n  text-decoration: none;\r\n  color: inherit;\r\n  background-color: inherit;\r\n  text-align: center;\r\n  cursor: pointer;\r\n}\r\n\r\n.w3-btn:hover {\r\n  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\r\n}\r\n\r\n.w3-btn,\r\n.w3-button {\r\n  -webkit-touch-callout: none;\r\n  -webkit-user-select: none;\r\n  -khtml-user-select: none;\r\n  -moz-user-select: none;\r\n  -ms-user-select: none;\r\n  user-select: none;\r\n}\r\n\r\n.w3-disabled,\r\n.w3-btn:disabled,\r\n.w3-button:disabled {\r\n  cursor: not-allowed;\r\n  opacity: 0.3;\r\n}\r\n\r\n.w3-disabled *,\r\n:disabled * {\r\n  pointer-events: none;\r\n}\r\n\r\n.w3-btn.w3-disabled:hover,\r\n.w3-btn:disabled:hover {\r\n  box-shadow: none;\r\n}\r\n\r\n.w3-badge,\r\n.w3-tag {\r\n  background-color: #000;\r\n  color: #fff;\r\n  display: inline-block;\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n  text-align: center;\r\n}\r\n\r\n.w3-badge {\r\n  border-radius: 50%;\r\n}\r\n\r\n.w3-ul {\r\n  list-style-type: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.w3-ul li {\r\n  padding: 8px 16px;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.edit-product-dialog {\r\n  color: #000;\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 95%;\r\n  height: 95%;\r\n  display: flex;\r\n  justify-content: center;\r\n  border-radius: 20px;\r\n  border-width: 3px;\r\n  border-color: #20295b;\r\n  align-items: center;\r\n  z-index: 9999;\r\n}\r\n\r\n.edit-product-dialog-content {\r\n  background-color: #fff;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  width: 90%;\r\n  max-height: 90%;\r\n  max-width: 95%;\r\n  overflow: auto;\r\n  border: 2px solid #20295b; /* Thin black border */\r\n}\r\n\r\n\r\n.edit-product-dialog button {\r\n  margin-top: 10px;\r\n  margin-right: 10px;\r\n}\r\n\r\n/* CSS styles for CookieConsent dialog */\r\n.CookieConsent {\r\n  position: fixed;\r\n  top: 50%;\r\n  left: 20%;\r\n  transform: scaleX(0.7);\r\n  background-color: #000;\r\n  color: #fff;\r\n  padding: 16px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n/* CSS styles for the \"Accept\" button in the CookieConsent dialog */\r\n.CookieConsent-button {\r\n  background-color: #3949a3;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 8px 16px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* CSS styles for the message text in the CookieConsent dialog */\r\n.CookieConsent-message {\r\n  margin-right: 16px;\r\n}\r\n\r\n.w3-ul li:last-child {\r\n  border-bottom: none;\r\n}\r\n\r\n.w3-tooltip,\r\n.w3-display-container {\r\n  position: relative;\r\n}\r\n\r\n.w3-tooltip .w3-text {\r\n  display: none;\r\n}\r\n\r\n.w3-tooltip:hover .w3-text {\r\n  display: inline-block;\r\n}\r\n\r\n.w3-ripple:active {\r\n  opacity: 0.5;\r\n}\r\n\r\n.w3-ripple {\r\n  transition: opacity 0s;\r\n}\r\n\r\n.w3-input {\r\n  padding: 8px;\r\n  display: block;\r\n  border: none;\r\n  border-bottom: 1px solid #ccc;\r\n  width: 100%;\r\n}\r\n\r\n.w3-select {\r\n  padding: 9px 0;\r\n  width: 100%;\r\n  border: none;\r\n  border-bottom: 1px solid #ccc;\r\n}\r\n\r\n.w3-dropdown-click,\r\n.w3-dropdown-hover {\r\n  position: relative;\r\n  display: inline-block;\r\n  cursor: pointer;\r\n}\r\n\r\n.w3-dropdown-hover:hover .w3-dropdown-content {\r\n  display: block;\r\n}\r\n\r\n.w3-dropdown-hover:first-child,\r\n.w3-dropdown-click:hover {\r\n  background-color: #ccc;\r\n  color: #000;\r\n}\r\n\r\n.w3-dropdown-hover:hover>.w3-button:first-child,\r\n.w3-dropdown-click:hover>.w3-button:first-child {\r\n  background-color: #ccc;\r\n  color: #000;\r\n}\r\n\r\n.w3-dropdown-content {\r\n  cursor: auto;\r\n  color: #000;\r\n  background-color: #fff;\r\n  display: none;\r\n  position: absolute;\r\n  min-width: 160px;\r\n  margin: 0;\r\n  padding: 0;\r\n  z-index: 1;\r\n}\r\n\r\n.w3-check,\r\n.w3-radio {\r\n  width: 24px;\r\n  height: 24px;\r\n  position: relative;\r\n  top: 6px;\r\n}\r\n\r\n.w3-sidebar {\r\n  height: 100%;\r\n  width: 200px;\r\n  background-color: #fff;\r\n  position: fixed !important;\r\n  z-index: 1;\r\n  overflow: auto;\r\n}\r\n\r\n.w3-bar-block .w3-dropdown-hover,\r\n.w3-bar-block .w3-dropdown-click {\r\n  width: 100%;\r\n}\r\n\r\n.w3-bar-block .w3-dropdown-hover .w3-dropdown-content,\r\n.w3-bar-block .w3-dropdown-click .w3-dropdown-content {\r\n  min-width: 100%;\r\n}\r\n\r\n.w3-bar-block .w3-dropdown-hover .w3-button,\r\n.w3-bar-block .w3-dropdown-click .w3-button {\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 8px 16px;\r\n}\r\n\r\n.w3-main,\r\n#main {\r\n  transition: margin-left 0.4s;\r\n}\r\n\r\n.w3-modal {\r\n  z-index: 3;\r\n  display: none;\r\n  padding-top: 100px;\r\n  position: fixed;\r\n  left: 0;\r\n  top: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: auto;\r\n  background-color: rgb(0, 0, 0);\r\n  background-color: rgba(0, 0, 0, 0.4);\r\n}\r\n\r\n.w3-modal-content {\r\n  margin: auto;\r\n  background-color: #fff;\r\n  position: relative;\r\n  padding: 0;\r\n  outline: 0;\r\n  width: 600px;\r\n}\r\n\r\n.w3-bar {\r\n  width: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.w3-center .w3-bar {\r\n  display: inline-block;\r\n  width: auto;\r\n}\r\n\r\n.w3-bar .w3-bar-item {\r\n  padding: 8px 16px;\r\n  float: left;\r\n  width: auto;\r\n  border: none;\r\n  display: block;\r\n  outline: 0;\r\n}\r\n\r\n.w3-bar .w3-dropdown-hover,\r\n.w3-bar .w3-dropdown-click {\r\n  position: static;\r\n  float: left;\r\n}\r\n\r\n.w3-bar .w3-button {\r\n  white-space: normal;\r\n}\r\n\r\n.w3-bar-block .w3-bar-item {\r\n  width: 100%;\r\n  display: block;\r\n  padding: 8px 16px;\r\n  text-align: left;\r\n  border: none;\r\n  white-space: normal;\r\n  float: none;\r\n  outline: 0;\r\n}\r\n\r\n.w3-bar-block.w3-center .w3-bar-item {\r\n  text-align: center;\r\n}\r\n\r\n.w3-block {\r\n  display: block;\r\n  width: 100%;\r\n}\r\n\r\n.w3-responsive {\r\n  display: block;\r\n  overflow-x: auto;\r\n}\r\n\r\n.w3-container:after,\r\n.w3-container:before,\r\n.w3-panel:after,\r\n.w3-panel:before,\r\n.w3-row:after,\r\n.w3-row:before,\r\n.w3-row-padding:after,\r\n.w3-row-padding:before,\r\n.w3-cell-row:before,\r\n.w3-cell-row:after,\r\n.w3-clear:after,\r\n.w3-clear:before,\r\n.w3-bar:before,\r\n.w3-bar:after {\r\n  content: '';\r\n  display: table;\r\n  clear: both;\r\n}\r\n\r\n.w3-col,\r\n.w3-half,\r\n.w3-third,\r\n.w3-twothird,\r\n.w3-threequarter,\r\n.w3-quarter {\r\n  float: left;\r\n  width: 100%;\r\n}\r\n\r\n.w3-col.s1 {\r\n  width: 8.33333%;\r\n}\r\n\r\n.w3-col.s2 {\r\n  width: 16.66666%;\r\n}\r\n\r\n.w3-col.s3 {\r\n  width: 24.99999%;\r\n}\r\n\r\n.w3-col.s4 {\r\n  width: 33.33333%;\r\n}\r\n\r\n.w3-col.s5 {\r\n  width: 41.66666%;\r\n}\r\n\r\n.w3-col.s6 {\r\n  width: 49.99999%;\r\n}\r\n\r\n.w3-col.s7 {\r\n  width: 58.33333%;\r\n}\r\n\r\n.w3-col.s8 {\r\n  width: 66.66666%;\r\n}\r\n\r\n.w3-col.s9 {\r\n  width: 74.99999%;\r\n}\r\n\r\n.w3-col.s10 {\r\n  width: 83.33333%;\r\n}\r\n\r\n.w3-col.s11 {\r\n  width: 91.66666%;\r\n}\r\n\r\n.w3-col.s12 {\r\n  width: 99.99999%;\r\n}\r\n\r\n@media (min-width: 601px) {\r\n  .w3-col.m1 {\r\n    width: 8.33333%;\r\n  }\r\n\r\n  .w3-col.m2 {\r\n    width: 16.66666%;\r\n  }\r\n\r\n  .w3-col.m3,\r\n  .w3-quarter {\r\n    width: 24.99999%;\r\n  }\r\n\r\n  .w3-col.m4,\r\n  .w3-third {\r\n    width: 33.33333%;\r\n  }\r\n\r\n  .w3-col.m5 {\r\n    width: 41.66666%;\r\n  }\r\n\r\n  .w3-col.m6,\r\n  .w3-half {\r\n    width: 49.99999%;\r\n  }\r\n\r\n  .w3-col.m7 {\r\n    width: 58.33333%;\r\n  }\r\n\r\n  .w3-col.m8,\r\n  .w3-twothird {\r\n    width: 66.66666%;\r\n  }\r\n\r\n  .w3-col.m9,\r\n  .w3-threequarter {\r\n    width: 74.99999%;\r\n  }\r\n\r\n  .w3-col.m10 {\r\n    width: 83.33333%;\r\n  }\r\n\r\n  .w3-col.m11 {\r\n    width: 91.66666%;\r\n  }\r\n\r\n  .w3-col.m12 {\r\n    width: 99.99999%;\r\n  }\r\n}\r\n\r\n@media (min-width: 993px) {\r\n  .w3-col.l1 {\r\n    width: 8.33333%;\r\n  }\r\n\r\n  .w3-col.l2 {\r\n    width: 16.66666%;\r\n  }\r\n\r\n  .w3-col.l3 {\r\n    width: 24.99999%;\r\n  }\r\n\r\n  .w3-col.l4 {\r\n    width: 33.33333%;\r\n  }\r\n\r\n  .w3-col.l5 {\r\n    width: 41.66666%;\r\n  }\r\n\r\n  .w3-col.l6 {\r\n    width: 49.99999%;\r\n  }\r\n\r\n  .w3-col.l7 {\r\n    width: 58.33333%;\r\n  }\r\n\r\n  .w3-col.l8 {\r\n    width: 66.66666%;\r\n  }\r\n\r\n  .w3-col.l9 {\r\n    width: 74.99999%;\r\n  }\r\n\r\n  .w3-col.l10 {\r\n    width: 83.33333%;\r\n  }\r\n\r\n  .w3-col.l11 {\r\n    width: 91.66666%;\r\n  }\r\n\r\n  .w3-col.l12 {\r\n    width: 99.99999%;\r\n  }\r\n}\r\n\r\n.w3-rest {\r\n  overflow: hidden;\r\n}\r\n\r\n.w3-stretch {\r\n  margin-left: -16px;\r\n  margin-right: -16px;\r\n}\r\n\r\n.w3-content,\r\n.w3-auto {\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n}\r\n\r\n.w3-content {\r\n  max-width: 980px;\r\n}\r\n\r\n.w3-auto {\r\n  max-width: 1140px;\r\n}\r\n\r\n.w3-cell-row {\r\n  display: table;\r\n  width: 100%;\r\n}\r\n\r\n.w3-cell {\r\n  display: table-cell;\r\n}\r\n\r\n.w3-cell-top {\r\n  vertical-align: top;\r\n}\r\n\r\n.w3-cell-middle {\r\n  vertical-align: middle;\r\n}\r\n\r\n.w3-cell-bottom {\r\n  vertical-align: bottom;\r\n}\r\n\r\n.w3-hide {\r\n  display: none !important;\r\n}\r\n\r\n.w3-show-block,\r\n.w3-show {\r\n  display: block !important;\r\n}\r\n\r\n.w3-show-inline-block {\r\n  display: inline-block !important;\r\n}\r\n\r\n@media (max-width: 1205px) {\r\n  .w3-auto {\r\n    max-width: 95%;\r\n  }\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .w3-modal-content {\r\n    margin: 0 10px;\r\n    width: auto !important;\r\n  }\r\n\r\n  .w3-modal {\r\n    padding-top: 30px;\r\n  }\r\n\r\n  .w3-dropdown-hover.w3-mobile .w3-dropdown-content,\r\n  .w3-dropdown-click.w3-mobile .w3-dropdown-content {\r\n    position: relative;\r\n  }\r\n\r\n  .w3-hide-small {\r\n    display: none !important;\r\n  }\r\n\r\n  .w3-mobile {\r\n    display: block;\r\n    width: 100% !important;\r\n  }\r\n\r\n  .w3-bar-item.w3-mobile,\r\n  .w3-dropdown-hover.w3-mobile,\r\n  .w3-dropdown-click.w3-mobile {\r\n    text-align: center;\r\n  }\r\n\r\n  .w3-dropdown-hover.w3-mobile,\r\n  .w3-dropdown-hover.w3-mobile .w3-btn,\r\n  .w3-dropdown-hover.w3-mobile .w3-button,\r\n  .w3-dropdown-click.w3-mobile,\r\n  .w3-dropdown-click.w3-mobile .w3-btn,\r\n  .w3-dropdown-click.w3-mobile .w3-button {\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .w3-modal-content {\r\n    width: 500px;\r\n  }\r\n\r\n  .w3-modal {\r\n    padding-top: 50px;\r\n  }\r\n}\r\n\r\n@media (min-width: 993px) {\r\n  .w3-modal-content {\r\n    width: 900px;\r\n  }\r\n\r\n  .w3-hide-large {\r\n    display: none !important;\r\n  }\r\n\r\n  .w3-sidebar.w3-collapse {\r\n    display: block !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 992px) and (min-width: 601px) {\r\n  .w3-hide-medium {\r\n    display: none !important;\r\n  }\r\n}\r\n\r\n@media (max-width: 992px) {\r\n  .w3-sidebar.w3-collapse {\r\n    display: none;\r\n  }\r\n\r\n  .w3-main {\r\n    margin-left: 0 !important;\r\n    margin-right: 0 !important;\r\n  }\r\n\r\n  .w3-auto {\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n.w3-top,\r\n.w3-bottom {\r\n  position:sticky;\r\n  width: 100%;\r\n  z-index: 1000;\r\n}\r\n\r\n.w3-top {\r\n  top: 0;\r\n}\r\n\r\n.w3-bottom {\r\n  bottom: 0;\r\n}\r\n\r\n.w3-overlay {\r\n  position: fixed;\r\n  display: none;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 2;\r\n}\r\n\r\n.w3-display-topleft {\r\n  position: absolute;\r\n  left: 0;\r\n  top: 0;\r\n}\r\n\r\n.w3-display-topright {\r\n  position: absolute;\r\n  right: 0;\r\n  top: 0;\r\n}\r\n\r\n.w3-display-bottomleft {\r\n  position: absolute;\r\n  left: 0;\r\n  bottom: 0;\r\n}\r\n\r\n.w3-display-bottomright {\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n}\r\n\r\n.w3-display-middle {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  -ms-transform: translate(-50%, -50%);\r\n}\r\n\r\n.w3-display-left {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 0%;\r\n  transform: translate(0%, -50%);\r\n  -ms-transform: translate(-0%, -50%);\r\n}\r\n\r\n.w3-display-right {\r\n  position: absolute;\r\n  top: 50%;\r\n  right: 0%;\r\n  transform: translate(0%, -50%);\r\n  -ms-transform: translate(0%, -50%);\r\n}\r\n\r\n.w3-display-topmiddle {\r\n  position: absolute;\r\n  left: 50%;\r\n  top: 0;\r\n  transform: translate(-50%, 0%);\r\n  -ms-transform: translate(-50%, 0%);\r\n}\r\n\r\n.w3-display-bottommiddle {\r\n  position: absolute;\r\n  left: 50%;\r\n  bottom: 0;\r\n  transform: translate(-50%, 0%);\r\n  -ms-transform: translate(-50%, 0%);\r\n}\r\n\r\n.w3-display-container:hover .w3-display-hover {\r\n  display: block;\r\n}\r\n\r\n.w3-display-container:hover span.w3-display-hover {\r\n  display: inline-block;\r\n}\r\n\r\n.w3-display-hover {\r\n  display: none;\r\n}\r\n\r\n.w3-display-position {\r\n  position: absolute;\r\n}\r\n\r\n.w3-circle {\r\n  border-radius: 50%;\r\n}\r\n\r\n.w3-round-small {\r\n  border-radius: 2px;\r\n}\r\n\r\n.w3-round,\r\n.w3-round-medium {\r\n  border-radius: 4px;\r\n}\r\n\r\n.w3-round-large {\r\n  border-radius: 8px;\r\n}\r\n\r\n.w3-round-xlarge {\r\n  border-radius: 16px;\r\n}\r\n\r\n.w3-round-xxlarge {\r\n  border-radius: 32px;\r\n}\r\n\r\n.w3-row-padding,\r\n.w3-row-padding>.w3-half,\r\n.w3-row-padding>.w3-third,\r\n.w3-row-padding>.w3-twothird,\r\n.w3-row-padding>.w3-threequarter,\r\n.w3-row-padding>.w3-quarter,\r\n.w3-row-padding>.w3-col {\r\n  padding: 0 8px;\r\n}\r\n\r\n.w3-container,\r\n.w3-panel {\r\n  padding: 0.01em 16px;\r\n}\r\n\r\n.w3-panel {\r\n  margin-top: 16px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.w3-code,\r\n.w3-codespan {\r\n  font-family: Consolas, 'courier new';\r\n  font-size: 16px;\r\n}\r\n\r\n.w3-code {\r\n  width: auto;\r\n  background-color: #fff;\r\n  padding: 8px 12px;\r\n  border-left: 4px solid #4caf50;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.w3-codespan {\r\n  color: crimson;\r\n  background-color: #f1f1f1;\r\n  padding-left: 4px;\r\n  padding-right: 4px;\r\n  font-size: 110%;\r\n}\r\n\r\n.w3-card,\r\n.w3-card-2 {\r\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.w3-card-4,\r\n.w3-hover-shadow:hover {\r\n  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.2), 0 4px 20px 0 rgba(0, 0, 0, 0.19);\r\n}\r\n\r\n.w3-spin {\r\n  animation: w3-spin 2s infinite linear;\r\n}\r\n\r\n@keyframes w3-spin {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  100% {\r\n    transform: rotate(359deg);\r\n  }\r\n}\r\n\r\n.w3-animate-fading {\r\n  animation: fading 10s infinite;\r\n}\r\n\r\n@keyframes fading {\r\n  0% {\r\n    opacity: 0;\r\n  }\r\n\r\n  50% {\r\n    opacity: 1;\r\n  }\r\n\r\n  100% {\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n.w3-animate-opacity {\r\n  animation: opac 0.8s;\r\n}\r\n\r\n@keyframes opac {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.w3-animate-top {\r\n  position: relative;\r\n  animation: animatetop 0.4s;\r\n}\r\n\r\n@keyframes animatetop {\r\n  from {\r\n    top: -300px;\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    top: 0;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.w3-animate-left {\r\n  position: relative;\r\n  animation: animateleft 0.4s;\r\n}\r\n\r\n@keyframes animateleft {\r\n  from {\r\n    left: -300px;\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    left: 0;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.w3-animate-right {\r\n  position: relative;\r\n  animation: animateright 0.4s;\r\n}\r\n\r\n@keyframes animateright {\r\n  from {\r\n    right: -300px;\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    right: 0;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.w3-animate-bottom {\r\n  position: relative;\r\n  animation: animatebottom 0.4s;\r\n}\r\n\r\n@keyframes animatebottom {\r\n  from {\r\n    bottom: -300px;\r\n    opacity: 0;\r\n  }\r\n\r\n  to {\r\n    bottom: 0;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.w3-animate-zoom {\r\n  animation: animatezoom 0.6s;\r\n}\r\n\r\n@keyframes animatezoom {\r\n  from {\r\n    transform: scale(0);\r\n  }\r\n\r\n  to {\r\n    transform: scale(1);\r\n  }\r\n}\r\n\r\n.w3-animate-input {\r\n  transition: width 0.4s ease-in-out;\r\n}\r\n\r\n.w3-animate-input:focus {\r\n  width: 100% !important;\r\n}\r\n\r\n.w3-opacity,\r\n.w3-hover-opacity:hover {\r\n  opacity: 0.6;\r\n}\r\n\r\n.w3-opacity-off,\r\n.w3-hover-opacity-off:hover {\r\n  opacity: 1;\r\n}\r\n\r\n.w3-opacity-max {\r\n  opacity: 0.25;\r\n}\r\n\r\n.w3-opacity-min {\r\n  opacity: 0.75;\r\n}\r\n\r\n.w3-greyscale-max,\r\n.w3-grayscale-max,\r\n.w3-hover-greyscale:hover,\r\n.w3-hover-grayscale:hover {\r\n  filter: grayscale(100%);\r\n}\r\n\r\n.w3-greyscale,\r\n.w3-grayscale {\r\n  filter: grayscale(75%);\r\n}\r\n\r\n.w3-greyscale-min,\r\n.w3-grayscale-min {\r\n  filter: grayscale(50%);\r\n}\r\n\r\n.w3-sepia {\r\n  filter: sepia(75%);\r\n}\r\n\r\n.w3-sepia-max,\r\n.w3-hover-sepia:hover {\r\n  filter: sepia(100%);\r\n}\r\n\r\n.w3-sepia-min {\r\n  filter: sepia(50%);\r\n}\r\n\r\n.w3-tiny {\r\n  font-size: 10px !important;\r\n}\r\n\r\n.w3-small {\r\n  font-size: 12px !important;\r\n}\r\n\r\n.w3-medium {\r\n  font-size: 15px !important;\r\n}\r\n\r\n.w3-large {\r\n  font-size: 18px !important;\r\n}\r\n\r\n.w3-xlarge {\r\n  font-size: 24px !important;\r\n}\r\n\r\n.w3-xxlarge {\r\n  font-size: 36px !important;\r\n}\r\n\r\n.w3-xxxlarge {\r\n  font-size: 48px !important;\r\n}\r\n\r\n.w3-jumbo {\r\n  font-size: 64px !important;\r\n}\r\n\r\n.w3-left-align {\r\n  text-align: left !important;\r\n}\r\n\r\n.w3-right-align {\r\n  text-align: right !important;\r\n}\r\n\r\n.w3-justify {\r\n  text-align: justify !important;\r\n}\r\n\r\n.w3-center {\r\n  text-align: center !important;\r\n}\r\n\r\n.w3-border-0 {\r\n  border: 0 !important;\r\n}\r\n\r\n.w3-border {\r\n  border: 1px solid #ccc !important;\r\n}\r\n\r\n.w3-border-top {\r\n  border-top: 1px solid #ccc !important;\r\n}\r\n\r\n.w3-border-bottom {\r\n  border-bottom: 1px solid #ccc !important;\r\n}\r\n\r\n.w3-border-left {\r\n  border-left: 1px solid #ccc !important;\r\n}\r\n\r\n.w3-border-right {\r\n  border-right: 1px solid #ccc !important;\r\n}\r\n\r\n.w3-topbar {\r\n  border-top: 6px solid #ccc !important;\r\n}\r\n\r\n.w3-bottombar {\r\n  border-bottom: 6px solid #ccc !important;\r\n}\r\n\r\n.w3-leftbar {\r\n  border-left: 6px solid #ccc !important;\r\n}\r\n\r\n.w3-rightbar {\r\n  border-right: 6px solid #ccc !important;\r\n}\r\n\r\n.w3-section,\r\n.w3-code {\r\n  margin-top: 16px !important;\r\n  margin-bottom: 16px !important;\r\n}\r\n\r\n.w3-margin {\r\n  margin: 16px !important;\r\n}\r\n\r\n.w3-margin-top {\r\n  margin-top: 16px !important;\r\n}\r\n\r\n.w3-margin-bottom {\r\n  margin-bottom: 16px !important;\r\n}\r\n\r\n.w3-margin-left {\r\n  margin-left: 16px !important;\r\n}\r\n\r\n.w3-margin-right {\r\n  margin-right: 16px !important;\r\n}\r\n\r\n.w3-padding-small {\r\n  padding: 4px 8px !important;\r\n}\r\n\r\n.w3-padding {\r\n  padding: 8px 16px !important;\r\n}\r\n\r\n.w3-padding-large {\r\n  padding: 12px 24px !important;\r\n}\r\n\r\n.w3-padding-16 {\r\n  padding-top: 16px !important;\r\n  padding-bottom: 16px !important;\r\n}\r\n\r\n.w3-padding-24 {\r\n  padding-top: 24px !important;\r\n  padding-bottom: 24px !important;\r\n}\r\n\r\n.w3-padding-32 {\r\n  padding-top: 32px !important;\r\n  padding-bottom: 32px !important;\r\n}\r\n\r\n.w3-padding-48 {\r\n  padding-top: 48px !important;\r\n  padding-bottom: 48px !important;\r\n}\r\n\r\n.w3-padding-64 {\r\n  padding-top: 64px !important;\r\n  padding-bottom: 64px !important;\r\n}\r\n\r\n.w3-padding-top-64 {\r\n  padding-top: 64px !important;\r\n}\r\n\r\n.w3-padding-top-48 {\r\n  padding-top: 48px !important;\r\n}\r\n\r\n.w3-padding-top-32 {\r\n  padding-top: 32px !important;\r\n}\r\n\r\n.w3-padding-top-24 {\r\n  padding-top: 24px !important;\r\n}\r\n\r\n.w3-left {\r\n  float: left !important;\r\n}\r\n\r\n.w3-right {\r\n  float: right !important;\r\n}\r\n\r\n.w3-button:hover {\r\n  color: #000 !important;\r\n  background-color: #ccc !important;\r\n}\r\n\r\n.w3-transparent,\r\n.w3-hover-none:hover {\r\n  background-color: transparent !important;\r\n}\r\n\r\n.w3-hover-none:hover {\r\n  box-shadow: none !important;\r\n}\r\n\r\n/* Colors */\r\n.w3-amber,\r\n.w3-hover-amber:hover {\r\n  color: #000 !important;\r\n  background-color: #ffc107 !important;\r\n}\r\n\r\n.w3-aqua,\r\n.w3-hover-aqua:hover {\r\n  color: #000 !important;\r\n  background-color: #00ffff !important;\r\n}\r\n\r\n.w3-blue,\r\n.w3-hover-blue:hover {\r\n  color: #fff !important;\r\n  background-color: #2196f3 !important;\r\n}\r\n\r\n.w3-light-blue,\r\n.w3-hover-light-blue:hover {\r\n  color: #000 !important;\r\n  background-color: #87ceeb !important;\r\n}\r\n\r\n.w3-brown,\r\n.w3-hover-brown:hover {\r\n  color: #fff !important;\r\n  background-color: #795548 !important;\r\n}\r\n\r\n.w3-cyan,\r\n.w3-hover-cyan:hover {\r\n  color: #000 !important;\r\n  background-color: #00bcd4 !important;\r\n}\r\n\r\n.w3-blue-grey,\r\n.w3-hover-blue-grey:hover,\r\n.w3-blue-gray,\r\n.w3-hover-blue-gray:hover {\r\n  color: #fff !important;\r\n  background-color: #607d8b !important;\r\n}\r\n\r\n.w3-green,\r\n.w3-hover-green:hover {\r\n  color: #fff !important;\r\n  background-color: #4caf50 !important;\r\n}\r\n\r\n.w3-light-green,\r\n.w3-hover-light-green:hover {\r\n  color: #000 !important;\r\n  background-color: #8bc34a !important;\r\n}\r\n\r\n.w3-indigo,\r\n.w3-hover-indigo:hover {\r\n  color: #fff !important;\r\n  background-color: #3f51b5 !important;\r\n}\r\n\r\n.w3-khaki,\r\n.w3-hover-khaki:hover {\r\n  color: #000 !important;\r\n  background-color: #f0e68c !important;\r\n}\r\n\r\n.w3-lime,\r\n.w3-hover-lime:hover {\r\n  color: #000 !important;\r\n  background-color: #cddc39 !important;\r\n}\r\n\r\n.w3-orange,\r\n.w3-hover-orange:hover {\r\n  color: #000 !important;\r\n  background-color: #ff9800 !important;\r\n}\r\n\r\n.w3-deep-orange,\r\n.w3-hover-deep-orange:hover {\r\n  color: #fff !important;\r\n  background-color: #ff5722 !important;\r\n}\r\n\r\n.w3-pink,\r\n.w3-hover-pink:hover {\r\n  color: #fff !important;\r\n  background-color: #e91e63 !important;\r\n}\r\n\r\n.w3-purple,\r\n.w3-hover-purple:hover {\r\n  color: #fff !important;\r\n  background-color: #9c27b0 !important;\r\n}\r\n\r\n.w3-deep-purple,\r\n.w3-hover-deep-purple:hover {\r\n  color: #fff !important;\r\n  background-color: #673ab7 !important;\r\n}\r\n\r\n.w3-red,\r\n.w3-hover-red:hover {\r\n  color: #fff !important;\r\n  background-color: #f44336 !important;\r\n}\r\n\r\n.w3-sand,\r\n.w3-hover-sand:hover {\r\n  color: #000 !important;\r\n  background-color: #fdf5e6 !important;\r\n}\r\n\r\n.w3-teal,\r\n.w3-hover-teal:hover {\r\n  color: #fff !important;\r\n  background-color: #009688 !important;\r\n}\r\n\r\n.w3-yellow,\r\n.w3-hover-yellow:hover {\r\n  color: #000 !important;\r\n  background-color: #ffeb3b !important;\r\n}\r\n\r\n.w3-white,\r\n.w3-hover-white:hover {\r\n  color: #000 !important;\r\n  background-color: #fff !important;\r\n}\r\n\r\n.w3-black,\r\n.w3-hover-black:hover {\r\n  color: #fff !important;\r\n  background-color: #000 !important;\r\n}\r\n\r\n.w3-grey,\r\n.w3-hover-grey:hover,\r\n.w3-gray,\r\n.w3-hover-gray:hover {\r\n  color: #000 !important;\r\n  background-color: #9e9e9e !important;\r\n}\r\n\r\n.w3-light-grey,\r\n.w3-hover-light-grey:hover,\r\n.w3-light-gray,\r\n.w3-hover-light-gray:hover {\r\n  color: #000 !important;\r\n  background-color: #f1f1f1 !important;\r\n}\r\n\r\n.w3-dark-grey,\r\n.w3-hover-dark-grey:hover,\r\n.w3-dark-gray,\r\n.w3-hover-dark-gray:hover {\r\n  color: #fff !important;\r\n  background-color: #616161 !important;\r\n}\r\n\r\n.w3-pale-red,\r\n.w3-hover-pale-red:hover {\r\n  color: #000 !important;\r\n  background-color: #ffdddd !important;\r\n}\r\n\r\n.w3-pale-green,\r\n.w3-hover-pale-green:hover {\r\n  color: #000 !important;\r\n  background-color: #ddffdd !important;\r\n}\r\n\r\n.w3-pale-yellow,\r\n.w3-hover-pale-yellow:hover {\r\n  color: #000 !important;\r\n  background-color: #ffffcc !important;\r\n}\r\n\r\n.w3-pale-blue,\r\n.w3-hover-pale-blue:hover {\r\n  color: #000 !important;\r\n  background-color: #ddffff !important;\r\n}\r\n\r\n.w3-text-amber,\r\n.w3-hover-text-amber:hover {\r\n  color: #ffc107 !important;\r\n}\r\n\r\n.w3-text-aqua,\r\n.w3-hover-text-aqua:hover {\r\n  color: #00ffff !important;\r\n}\r\n\r\n.w3-text-blue,\r\n.w3-hover-text-blue:hover {\r\n  color: #2196f3 !important;\r\n}\r\n\r\n.w3-text-light-blue,\r\n.w3-hover-text-light-blue:hover {\r\n  color: #87ceeb !important;\r\n}\r\n\r\n.w3-text-brown,\r\n.w3-hover-text-brown:hover {\r\n  color: #795548 !important;\r\n}\r\n\r\n.w3-text-cyan,\r\n.w3-hover-text-cyan:hover {\r\n  color: #00bcd4 !important;\r\n}\r\n\r\n.w3-text-blue-grey,\r\n.w3-hover-text-blue-grey:hover,\r\n.w3-text-blue-gray,\r\n.w3-hover-text-blue-gray:hover {\r\n  color: #607d8b !important;\r\n}\r\n\r\n.w3-text-green,\r\n.w3-hover-text-green:hover {\r\n  color: #4caf50 !important;\r\n}\r\n\r\n.w3-text-light-green,\r\n.w3-hover-text-light-green:hover {\r\n  color: #8bc34a !important;\r\n}\r\n\r\n.w3-text-indigo,\r\n.w3-hover-text-indigo:hover {\r\n  color: #3f51b5 !important;\r\n}\r\n\r\n.w3-text-khaki,\r\n.w3-hover-text-khaki:hover {\r\n  color: #b4aa50 !important;\r\n}\r\n\r\n.w3-text-lime,\r\n.w3-hover-text-lime:hover {\r\n  color: #cddc39 !important;\r\n}\r\n\r\n.w3-text-orange,\r\n.w3-hover-text-orange:hover {\r\n  color: #ff9800 !important;\r\n}\r\n\r\n.w3-text-deep-orange,\r\n.w3-hover-text-deep-orange:hover {\r\n  color: #ff5722 !important;\r\n}\r\n\r\n.w3-text-pink,\r\n.w3-hover-text-pink:hover {\r\n  color: #e91e63 !important;\r\n}\r\n\r\n.w3-text-purple,\r\n.w3-hover-text-purple:hover {\r\n  color: #9c27b0 !important;\r\n}\r\n\r\n.w3-text-deep-purple,\r\n.w3-hover-text-deep-purple:hover {\r\n  color: #673ab7 !important;\r\n}\r\n\r\n.w3-text-red,\r\n.w3-hover-text-red:hover {\r\n  color: #f44336 !important;\r\n}\r\n\r\n.w3-text-sand,\r\n.w3-hover-text-sand:hover {\r\n  color: #fdf5e6 !important;\r\n}\r\n\r\n.w3-text-teal,\r\n.w3-hover-text-teal:hover {\r\n  color: #009688 !important;\r\n}\r\n\r\n.w3-text-yellow,\r\n.w3-hover-text-yellow:hover {\r\n  color: #d2be0e !important;\r\n}\r\n\r\n.w3-text-white,\r\n.w3-hover-text-white:hover {\r\n  color: #fff !important;\r\n}\r\n\r\n.w3-text-black,\r\n.w3-hover-text-black:hover {\r\n  color: #000 !important;\r\n}\r\n\r\n.w3-text-grey,\r\n.w3-hover-text-grey:hover,\r\n.w3-text-gray,\r\n.w3-hover-text-gray:hover {\r\n  color: #757575 !important;\r\n}\r\n\r\n.w3-text-light-grey,\r\n.w3-hover-text-light-grey:hover,\r\n.w3-text-light-gray,\r\n.w3-hover-text-light-gray:hover {\r\n  color: #f1f1f1 !important;\r\n}\r\n\r\n.w3-text-dark-grey,\r\n.w3-hover-text-dark-grey:hover,\r\n.w3-text-dark-gray,\r\n.w3-hover-text-dark-gray:hover {\r\n  color: #3a3a3a !important;\r\n}\r\n\r\n.w3-border-amber,\r\n.w3-hover-border-amber:hover {\r\n  border-color: #ffc107 !important;\r\n}\r\n\r\n.w3-border-aqua,\r\n.w3-hover-border-aqua:hover {\r\n  border-color: #00ffff !important;\r\n}\r\n\r\n.w3-border-blue,\r\n.w3-hover-border-blue:hover {\r\n  border-color: #2196f3 !important;\r\n}\r\n\r\n.w3-border-light-blue,\r\n.w3-hover-border-light-blue:hover {\r\n  border-color: #87ceeb !important;\r\n}\r\n\r\n.w3-border-brown,\r\n.w3-hover-border-brown:hover {\r\n  border-color: #795548 !important;\r\n}\r\n\r\n.w3-border-cyan,\r\n.w3-hover-border-cyan:hover {\r\n  border-color: #00bcd4 !important;\r\n}\r\n\r\n.w3-border-blue-grey,\r\n.w3-hover-border-blue-grey:hover,\r\n.w3-border-blue-gray,\r\n.w3-hover-border-blue-gray:hover {\r\n  border-color: #607d8b !important;\r\n}\r\n\r\n.w3-border-green,\r\n.w3-hover-border-green:hover {\r\n  border-color: #4caf50 !important;\r\n}\r\n\r\n.w3-border-light-green,\r\n.w3-hover-border-light-green:hover {\r\n  border-color: #8bc34a !important;\r\n}\r\n\r\n.w3-border-indigo,\r\n.w3-hover-border-indigo:hover {\r\n  border-color: #3f51b5 !important;\r\n}\r\n\r\n.w3-border-khaki,\r\n.w3-hover-border-khaki:hover {\r\n  border-color: #f0e68c !important;\r\n}\r\n\r\n.w3-border-lime,\r\n.w3-hover-border-lime:hover {\r\n  border-color: #cddc39 !important;\r\n}\r\n\r\n.w3-border-orange,\r\n.w3-hover-border-orange:hover {\r\n  border-color: #ff9800 !important;\r\n}\r\n\r\n.w3-border-deep-orange,\r\n.w3-hover-border-deep-orange:hover {\r\n  border-color: #ff5722 !important;\r\n}\r\n\r\n.w3-border-pink,\r\n.w3-hover-border-pink:hover {\r\n  border-color: #e91e63 !important;\r\n}\r\n\r\n.w3-border-purple,\r\n.w3-hover-border-purple:hover {\r\n  border-color: #9c27b0 !important;\r\n}\r\n\r\n.w3-border-deep-purple,\r\n.w3-hover-border-deep-purple:hover {\r\n  border-color: #673ab7 !important;\r\n}\r\n\r\n.w3-border-red,\r\n.w3-hover-border-red:hover {\r\n  border-color: #f44336 !important;\r\n}\r\n\r\n.w3-border-sand,\r\n.w3-hover-border-sand:hover {\r\n  border-color: #fdf5e6 !important;\r\n}\r\n\r\n.w3-border-teal,\r\n.w3-hover-border-teal:hover {\r\n  border-color: #009688 !important;\r\n}\r\n\r\n.w3-border-yellow,\r\n.w3-hover-border-yellow:hover {\r\n  border-color: #ffeb3b !important;\r\n}\r\n\r\n.w3-border-white,\r\n.w3-hover-border-white:hover {\r\n  border-color: #fff !important;\r\n}\r\n\r\n.w3-border-black,\r\n.w3-hover-border-black:hover {\r\n  border-color: #000 !important;\r\n}\r\n\r\n.w3-border-grey,\r\n.w3-hover-border-grey:hover,\r\n.w3-border-gray,\r\n.w3-hover-border-gray:hover {\r\n  border-color: #9e9e9e !important;\r\n}\r\n\r\n.w3-border-light-grey,\r\n.w3-hover-border-light-grey:hover,\r\n.w3-border-light-gray,\r\n.w3-hover-border-light-gray:hover {\r\n  border-color: #f1f1f1 !important;\r\n}\r\n\r\n.w3-border-dark-grey,\r\n.w3-hover-border-dark-grey:hover,\r\n.w3-border-dark-gray,\r\n.w3-hover-border-dark-gray:hover {\r\n  border-color: #616161 !important;\r\n}\r\n\r\n.w3-border-pale-red,\r\n.w3-hover-border-pale-red:hover {\r\n  border-color: #ffe7e7 !important;\r\n}\r\n\r\n.w3-border-pale-green,\r\n.w3-hover-border-pale-green:hover {\r\n  border-color: #e7ffe7 !important;\r\n}\r\n\r\n.w3-border-pale-yellow,\r\n.w3-hover-border-pale-yellow:hover {\r\n  border-color: #ffffcc !important;\r\n}\r\n\r\n.w3-border-pale-blue,\r\n.w3-hover-border-pale-blue:hover {\r\n  border-color: #e7ffff !important;\r\n}\r\n\r\ntd:nth-child(1) {\r\n  background-color: rgb(43, 45, 133);\r\n  color: white;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
